import axios from 'axios';

const model = 'Asignatura';
const API_URL = process.env.VUE_APP_API_URL;

export default {
  get() {
    return axios.get(`${API_URL}/${model}/v1/list`);
  },

  /** @param {{ glosa?: string, vigente?: boolean, iPais?: number }} params */
  listar(params = {}) {
    const query = new URLSearchParams();
    if (params.glosa != null && params.glosa !== '') query.append('glosa', params.glosa);
    if (typeof params.vigente === 'boolean') query.append('vigente', String(params.vigente));
    if (params.iPais > 0) query.append('iPais', params.iPais);
    const qs = query.toString();
    return axios.get(`${API_URL}/${model}/v1/list${qs ? `?${qs}` : ''}`);
  },

  listarPaginado(page = 1, size = 500) {
    return axios.get(`${API_URL}/${model}/v1/list/${page}/${size}`);
  },

  getById(id) {
    return axios.get(`${API_URL}/${model}/v1/${id}`);
  },

  crear(payload) {
    return axios.post(`${API_URL}/${model}/v1`, payload);
  },

  actualizar(id, payload) {
    return axios.put(`${API_URL}/${model}/v1?id=${id}`, payload);
  },
};